import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useRecurringPayables, RecurringPayable } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';

const List: React.FC = () => {
  const { colors } = useTheme();
  return (
    <GenericListPage<RecurringPayable>
      useData={useRecurringPayables}
      config={{
        ...moduleConfig,
        getColumns: (_formatDate, formatCurrency) => getColumns(formatCurrency || moduleConfig.utils.formatCurrency, colors),
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
